// Canonical names remain public. Instance numbers are presentation only.
export function combatantLabel(entity, {
  dm = false,
  fallback = 'Creature'
} = {}) {
  if (!entity || typeof entity !== 'object') return fallback;
  const naming = entity.enemyNaming;
  const name = String(entity.characterName || entity.name || entity.displayName || fallback).trim() || fallback;
  const beast = entity.classState?.druid?.wildShape?.form?.name;
  if (beast) return `${name} (${beast})`;
  if (dm && naming && !naming.customName && name === naming.baseName && Number.isInteger(naming.number) && naming.number > 0) return `${name} ${naming.number}`;
  return name;
}
